export default __webpack_public_path__ + "static/media/antena.3c18599d.png";